// extracted by mini-css-extract-plugin
module.exports = {"content":"newNotification_content__LuqcO","notification":"newNotification_notification__1s-q4"};